import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Plus, Trash2 } from 'lucide-react';

const ArraySection = (props) => {
    const { title, description, name, itemSchema, renderItem } = props;
    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({
        control,
        name
    });

    const handleAdd = () => {
        append(itemSchema);
    };

    const handleRemove = (index) => {
        remove(index);
    };

    return (
        <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 mb-6">
            <div className="md:grid md:grid-cols-3 md:gap-6">
                <div className="md:col-span-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">{title}</h3>
                    <p className="mt-1 text-sm text-gray-500">
                        {description}
                    </p>
                    <button
                        type="button"
                        onClick={handleAdd}
                        className="mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        <Plus className="-ml-1 mr-2 h-5 w-5" />
                        Add {title.slice(0, -1)}
                    </button>
                </div>
                <div className="mt-5 md:mt-0 md:col-span-2">
                    {fields.length === 0 ? (
                        <div className="text-center py-6 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                            <p className="text-sm text-gray-500">No items added yet.</p>
                        </div>
                    ) : (
                        <div className="space-y-6">
                            {fields.map((field, index) => {
                                const itemProps = { index, field };
                                return (
                                    <div key={field.id} className="relative bg-gray-50 p-4 rounded-lg border border-gray-200">
                                        <div className="absolute top-4 right-4">
                                            <button
                                                type="button"
                                                onClick={() => handleRemove(index)}
                                                className="text-red-500 hover:text-red-700 p-1"
                                                title="Remove Item"
                                            >
                                                <Trash2 className="h-5 w-5" />
                                            </button>
                                        </div>
                                        {renderItem(itemProps)}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ArraySection;
